<ion-card mode="ios" [ngClass]="{ xScroll: scrollEnabled}">
    <ion-card-header color="" [ngStyle]="headerWidth">
        <ion-card-title color="primary">
            {{ titleKey | translate | uppercase }}
        </ion-card-title>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
        <ng-container *ngIf="evaluations && evaluations.length > 0">
            <ng-container *ngIf="!scrollEnabled; else scrollEnabledTemplate">
                <ion-grid class="team">
                    <ion-row class="header">
                        <ion-row class="topAlign">
                            <ion-col size="1"></ion-col>
                            <ion-col [attr.size]="scrollEnabled ? columnSize : null" class="ion-text-center"
                                     *ngFor="
                                            let question of getQuestions(processConfig);
                                            let index = index
                                          "
                            >
                                {{ getText(question.globalizationConfig, "title") }}
                            </ion-col>
                        </ion-row>
                    </ion-row>
                    <ion-row class="body"
                             *ngFor="let evaluation of evaluations; let indexEval = index"
                             style="width: 100%"
                    >
                        <ion-row class="topAlign">
                            <ion-col size="1"
                                     class="evaluator noBorder centralized ion-text-center ion-align-items-center"
                                     [class.showLess]="!show.showQuestions[indexEval] && showMoreLess"
                                     [class.showMore]="show.showQuestions[indexEval] && showMoreLess"
                            >
                                <img
                                        [src]="
                                            !evaluation.evaluator.external
                                              ? getImageUrl(evaluation.evaluator.imageUrl)
                                              : './assets/imgs/external-user-placeholder.png'
                                          "
                                        default=""
                                        class="avatar"
                                />
                                <h3>{{ evaluation.evaluator.name }}</h3>
                            </ion-col>
                            <ion-col [attr.size]="scrollEnabled ? columnSize : null"
                                     class="question ion-text-center"
                                     *ngFor="
                                          let question of getQuestions(processConfig);
                                          let index = index
                                        "
                            >
                                <ion-row
                                        class="noBorder topAlign centralized"
                                        [class.showLess]="!show.showQuestions[indexEval] && showMoreLess"
                                        [class.showMore]="show.showQuestions[indexEval] && showMoreLess"
                                >
                                    <p>
                                        {{
                                        isNumber(evaluation["field" + (index + 1)])
                                            ? evaluation["field" + (index + 1)]
                                            : question.typeConfig.possibleValuesGlobalized[
                                                selectedLanguage
                                                ][getIndex(evaluation["field" + (index + 1)])]
                                        }}
                                    </p>
                                </ion-row>
                            </ion-col>
                            <ion-row
                                    *ngIf="showMoreLess"
                                    class="noBorder showClick"
                                    style="width: 100%"
                            >
                            <span (click)="show.showQuestions[indexEval] = !show.showQuestions[indexEval]"
                                  class="clickable">
                                {{
                                show.showQuestions[indexEval]
                                    ? ("generic.showLess" | translate)
                                    : ("generic.showMore" | translate)
                                }}
                            </span>
                            </ion-row>
                        </ion-row>
                    </ion-row>
                </ion-grid>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="evaluations && evaluations.length === 0">
            <p class="ion-padding">
                {{ "generic.noEvaluations" | translate }}
            </p>
        </ng-container>
    </ion-card-content>
</ion-card>

<ng-template #scrollEnabledTemplate>
    <ion-grid class="team" [ngStyle]="headerWidth">
        <ion-row class="header">
            <ion-row class="topAlign">
                <ion-col class="setFirstColWidth"></ion-col>
                <ion-col class="setWidth ion-text-center"
                         *ngFor="
                                            let question of getQuestions(processConfig);
                                            let index = index
                                          "
                >
                    <p class="setWidth">{{ getText(question.globalizationConfig, "title") }}</p>
                </ion-col>
            </ion-row>
        </ion-row>
        <ion-row class="body" *ngFor="let evaluation of evaluations; let indexEval = index">
            <ion-row class="topAlign">
                <ion-col class="noBorder setFirstColWidth evaluatorData"
                         [class.showLess]="!show.showQuestions[indexEval] && showMoreLess"
                         [class.showMore]="show.showQuestions[indexEval] && showMoreLess"
                >
                    <img class="avatar"
                         default=""
                         [src]="!evaluation.evaluator.external
                                      ? getImageUrl(evaluation.evaluator.imageUrl)
                                      : './assets/imgs/external-user-placeholder.png'
                                  "
                         [alt]=""
                    />
                    <h3 class="setFirstColWidth">{{ evaluation.evaluator.name }}</h3>
                </ion-col>
                <ion-col class="noBorder topAlign setWidth ion-text-center"
                         [class.showLess]="!show.showQuestions[indexEval] && showMoreLess"
                         [class.showMore]="show.showQuestions[indexEval] && showMoreLess"
                         *ngFor="
                                          let question of getQuestions(processConfig);
                                          let index = index
                                        "
                >
                    <h3 class="setWidth">
                        {{
                        isNumber(evaluation["field" + (index + 1)])
                            ? evaluation["field" + (index + 1)]
                            : question.typeConfig.possibleValuesGlobalized[
                                selectedLanguage
                                ][getIndex(evaluation["field" + (index + 1)])]
                        }}
                    </h3>
                </ion-col>
                <ion-row
                        *ngIf="showMoreLess"
                        class="noBorder showClick"
                        style="width: 100%"
                >
                            <span (click)="show.showQuestions[indexEval] = !show.showQuestions[indexEval]"
                                  class="clickable">
                                {{
                                show.showQuestions[indexEval]
                                    ? ("generic.showLess" | translate)
                                    : ("generic.showMore" | translate)
                                }}
                            </span>
                </ion-row>
            </ion-row>
        </ion-row>
    </ion-grid>
</ng-template>